import React from 'react'
import { AccountSwitcherMode, EmailLogEventType } from '@barracuda-internal/converged-email-log'

import AccountSwitcher from 'components/libs/accountSwitcher/AccountSwitcher'
import AccountSwitcherEmailProtectionAll from 'components/libs/accountSwitcher/accountSwitcherEmailProtection/AccountSwitcherEmailProtectionAll'
import { useAppSelector } from 'redux/toolkit/hooks'
import AccountSwitcherEmailProtectionSingle from 'components/libs/accountSwitcher/accountSwitcherEmailProtection/AccountSwitcherEmailProtectionSingle'

const AccountSwitcherSelector = () => {
  const { accountSwitcherEvent } = useAppSelector(_store => ({
    accountSwitcherEvent: _store.app.accountSwitcherEvent
  }))

  // Type guard for  unset and invalid events
  if (accountSwitcherEvent === null || accountSwitcherEvent?.type !== EmailLogEventType.ACCOUNT_SWITCHER_MODE_SET) {
    return <AccountSwitcher />
  }

  switch (accountSwitcherEvent.payload.mode) {
    case AccountSwitcherMode.EP_ON_ALL_ACCOUNTS: {
      return <AccountSwitcherEmailProtectionAll />
    }
    case AccountSwitcherMode.EP_ON_SINGLE_ACCOUNT: {
      return (
        <AccountSwitcherEmailProtectionSingle
          accounts={accountSwitcherEvent.payload.accounts}
          selectedAccountId={accountSwitcherEvent.payload.bccAccountId}
        />
      )
    }
    case AccountSwitcherMode.EP_OFF: {
      return null
    }
    case AccountSwitcherMode.HOST:
    default: {
      return <AccountSwitcher />
    }
  }
}

export default AccountSwitcherSelector
